import * as React from 'react'

import { DaySplit } from './daysplit'
import { MonthSplit } from './monthsplit'
import { YearSplit } from './yearsplit'

type Props = {
  handleChange: (field, value) => void
  error?: string
  currentYear: number
  currentMonth: number
  currentDay: number
  minDay: number
  minMonth: number
  minYear: string
  minimumAge: number
  monthAnchorId?: string
  dayAnchorId?: string
  yearAnchorId?: string
  format?: DateFormat
  locale?: string
}

export enum DateFormat {
  MONTH_DAY_YEAR,
  YEAR_MONTH_DAY,
}

export class SplitBirthdayOrganizer extends React.Component<Props> {
  public static defaultProps = {
    format: DateFormat.MONTH_DAY_YEAR,
  }
  public render() {
    const {
      error,
      handleChange,
      currentYear,
      currentMonth,
      currentDay,
      minDay,
      minMonth,
      minYear,
      minimumAge,
      monthAnchorId,
      dayAnchorId,
      yearAnchorId,
      format,
      locale,
    } = this.props

    switch (format) {
      case DateFormat.YEAR_MONTH_DAY:
        return (
          <React.Fragment>
            <YearSplit
              currentYear={currentYear}
              minYear={minYear}
              minimumAge={minimumAge}
              handleChange={handleChange}
              error={error}
              yearAnchorId={yearAnchorId}
              locale={locale}
            />
            <MonthSplit
              currentMonth={currentMonth}
              minMonth={minMonth}
              handleChange={handleChange}
              error={error}
              monthAnchorId={monthAnchorId}
              locale={locale}
            />
            <DaySplit
              currentDay={currentDay}
              minDay={minDay}
              handleChange={handleChange}
              error={error}
              dayAnchorId={dayAnchorId}
              locale={locale}
            />
          </React.Fragment>
        )
      case DateFormat.MONTH_DAY_YEAR:
      default:
        return (
          <React.Fragment>
            <MonthSplit
              currentMonth={currentMonth}
              minMonth={minMonth}
              handleChange={handleChange}
              error={error}
              monthAnchorId={monthAnchorId}
              locale={locale}
            />
            <DaySplit
              currentDay={currentDay}
              minDay={minDay}
              handleChange={handleChange}
              error={error}
              dayAnchorId={dayAnchorId}
              locale={locale}
            />
            <YearSplit
              currentYear={currentYear}
              minYear={minYear}
              minimumAge={minimumAge}
              handleChange={handleChange}
              error={error}
              yearAnchorId={yearAnchorId}
              locale={locale}
            />
          </React.Fragment>
        )
    }
  }
}

export default SplitBirthdayOrganizer
